import { render, staticRenderFns } from "./CreateBusinessuser.vue?vue&type=template&id=ef1f8822&"
import script from "./CreateBusinessuser.vue?vue&type=script&lang=js&"
export * from "./CreateBusinessuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports